import { render, staticRenderFns } from "./AmountInfraCard.vue?vue&type=template&id=2e08f0c4"
import script from "./AmountInfraCard.vue?vue&type=script&lang=js"
export * from "./AmountInfraCard.vue?vue&type=script&lang=js"
import style0 from "./AmountInfraCard.vue?vue&type=style&index=0&id=2e08f0c4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports